import { Component, OnInit, ɵConsole } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import * as XLSX from 'xlsx';
import * as colabInter from './colaboradores35.interface';
import * as backInter from 'app/auth/auth-data.model';
// ColaboradoresEncuestadorService
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { WizardN35EncuestadorService } from 'app/main/wizard-n35encuestador/services/wizardn35encuestador.services';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';

///IDIOMAS
// import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_certificar } from 'app/idiomas/i18n/encuestador35/encuestador35.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { from } from 'rxjs';
import { zonasUTC } from 'app/main/pagina/zonasUtc';

type AOA = any[][];

const moment = require('moment');
const momentTz = require('moment-timezone');

@Component({
  selector: 'app-colaboradores35',
  templateUrl: './colaboradores35.component.html',
  styleUrls: ['./colaboradores35.component.scss'],
  animations : fuseAnimations
})
export class Colaboradores35Component implements OnInit {
  cargando = true;
  cargando_CT = true;
  cargandoBD = false;
  cargandadoBDSegunda = false;
  guardandoBD = false;
  guardandoBD_CT = false;
  stored = false;
  stored_CT = false;
  status_CT = false;
  status_COLAB = false;

  colabsEnBD = 0;
  CT_EnBD = 0;
  fechaCarga:string;
  fechaCarga_CT:string;
  idiomaActual:string;
  instituto: string;
  nombreEmpresa: string;
  regexAlfabetico = new RegExp("^[a-zA-Z ÁÉÍÓÚÜáéíóúüñÑ()/&.,:_-]*$");
  regexAlfanumerico = new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ()°/&.,:_-]*$");
	regexNumerico = new RegExp("^[0-9]+$");
  regexEmail = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$");
  regexClave = new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ()°/&_-]*$");
  data: AOA = [];
  dataSegunda: AOA = [];
  files: any = [];
  totRows = 0;
  arregloColaboradores: colabInter.Colaborador[] = [];
  arregloCentro_Trabajo: colabInter.CentroTrabajo[] = [];
  sheet_number: any;
  errores:colabInter.errorEncontrado[] = [];
  erroresTotales = 0;
  errores_CT:colabInter.errorEncontrado[] = [];
  erroresTotales_CT = 0;
  nombresColumnas: string[] = [];
  clavesColumnas: string[] = [];
  nombresColumnas_CT: string[] = [];
  clavesColumnas_CT: string[] = [];
  nombresColumnasBD = {} as colabInter.nombresColumnasEnBD;
  // Datos certificar vigente
  productoCertificar: backInter.prodNorma35;
  //boolean paso completo
  pasoCompleto = false;

  // FROM HERE START SECOND PAGE
  nombresColumnasBD_CT = {} as colabInter.nombresColumnasEnBDCT;
  productoCertificar_CT: backInter.prodNorma35;
  flag_sheet1_errors = 0;
  flag_sheet2_errors = 0;
  //nombres de hojas de Excel
  wsName_ct: string;
  wsName_co: string;
  //arreglo de ID de centros de trabajo
  idsCentrosTrabajo: number[] = [];
  //etiquetas para encontrar los textos de traduccion
  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_1',
    'CERTIFICAR.COLABORADORES.MENSAJES.GUARDA_2',
    'CERTIFICAR.COLABORADORES.MENSAJES.GUARDADO',
    'CERTIFICAR.COLABORADORES.MENSAJES.GUA_ERR',
    'CERTIFICAR.COLABORADORES.MENSAJES.DELETE_1',
    'CERTIFICAR.COLABORADORES.MENSAJES.DELETE_2',
    'CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_1',
    'CERTIFICAR.COLABORADORES.MENSAJES.DEL_OK_2',
    'CERTIFICAR.COLABORADORES.MENSAJES.DEL_ERR',
    'CERTIFICAR.COLABORADORES.MENSAJES.DELFILE',
    'CERTIFICAR.COLABORADORES.MENSAJES.EXCEL',
    'CERTIFICAR.COLABORADORES.MENSAJES.EXTMAL',
    'CERTIFICAR.COLABORADORES.MENSAJES.NOROWS',
    'CERTIFICAR.COLABORADORES.MENSAJES.VACIO',
    'CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.SI',
    'CERTIFICAR.COLABORADORES.MENSAJES.BOTONES.NO',
    'CERTIFICAR.COLABORADORES.EXCELINFO.HOJA',
    'CERTIFICAR.COLABORADORES.EXCELINFO.TITULO',
    'CERTIFICAR.COLABORADORES.EXCELINFO.AUTOR',
    'CERTIFICAR.COLABORADORES.EXCELINFO.ASUNTO',
    'CERTIFICAR.IDIOMAS.MENSAJES.ERRORDEL'
  ];
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    guarda_1: '',
    guarda_2: '',
    guardado: '',
    gua_err: '',
    delete_1: '',
    delete_2: '',
    del_ok_1: '',
    del_ok_2: '',
    del_err: '',
    delfile: '',
    excel: '',
    extmal: '',
    norows: '',
    vacio: '',
    si: '',
    no: '',
    hoja: '',
    titulo: '',
    autor: '',
    asunto: '',
    errDel: ''
  };

  //zonas horarias
  zonasUTC = zonasUTC;
  idiomaUtc: string;
  instUtc: number;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;

  constructor(
    private colaboradoresService: ColaboradoresEncuestadorService,
    private wizardService: WizardService,
    private wizardService35: WizardN35EncuestadorService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    //obtiene id instituto
    this.obtieneInstituto();
  }

  ngOnInit() {
    this.obtieneCertificarActual();
    this.traduceTextosTS();
  }

  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; this.instUtc = 1;  break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; this.instUtc = 2; break;
      case '3': case 'HK': this.instituto = 'HK'; this.instUtc = 3; break;
      case '4': case 'SGP': this.instituto = 'WLDWDE'; this.instUtc = 4;  break;
      case '5': case 'TK': this.instituto = 'TK'; this.instUtc = 5; break;
      case '6': case 'FL': this.instituto = 'WLDWDE'; this.instUtc = 6;  break;
      case '11': case 'BR': this.instituto = 'WLDWDE'; this.instUtc = 11;  break;
      case '15': case 'ES': this.instituto = 'WLDWDE'; this.instUtc = 15;  break;
      default: this.instituto = 'WLDWDE';
    }
    //se coloca aqui porque dentro de esa funcion se requiere tener el instituto
    this.traduceTextosTS();
    //calculo de zona utc
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instUtc);
    this.calculoOffsetPipe();
  }


  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;

      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
              if(producto.completoNorma35 === 1){
                this.productoCertificar = producto;
                this.productoCertificar_CT = producto;
                throw BreakException;
              }
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      // IMPORTANTE!!!! ESTO SE DEBE VERIFICAR
      this.colaboradoresService.getStatu(this.productoCertificar.idNorma35,true).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3){
          this.pasoCompleto = true;
        }
      });
      //obtiene los colaboradores guardados y fecha de carga
      this.getColaboradoresFast();
      this.getCentrosFast();
      //obtiene nombre empresa
      this.wizardService.getInfoEmpresa().subscribe((data:backInter.infoEmpresa) => {
        this.nombreEmpresa = data.data.nombreEmpresa;
      });
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
    this.idiomaUtc = this.translateSrv.currentLang;
  }

  getCentrosFast(){
    this.colaboradoresService.getCentrosFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35).subscribe( (getFast: colabInter.getBD_CTFast) => {
      console.log(getFast);
      if(getFast.message == 'Success' && getFast.numeroCentrosTrabajo > 0){
        //this.status_CT=true;
        console.log(getFast);
        this.stored_CT = true;
        this.CT_EnBD = getFast.numeroCentrosTrabajo;
        this.fechaCarga_CT = getFast.fecha;

      }else{

          let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.INFORMATIVO';
          this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
          let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
          let rspSi = 'MODALES.ACCIONES.aceptar';
          this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
          this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });

          Swal.fire({
            icon: 'info',
            title: texto,
            //input: "checkbox",
            //inputPlaceholder: botonModal,
            /*inputValidator: (result)=>{
              //alert(result);
              return new Promise((resolve)=>{

                resolve();
              });
            },*/

            confirmButtonText: rspSi,
            allowOutsideClick: false
          })



      }
      this.cargando_CT = false;
    });
  }

  getColaboradoresFast(){
    this.colaboradoresService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35).subscribe( (getFast: colabInter.getBDFast) => {

      if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
        //this.status_COLAB= true;

        this.stored = true;
        this.colabsEnBD = getFast.numeroColaboradores;
        this.fechaCarga = getFast.fecha;
      }
      this.cargando = false;
    });
  }

  ////LEER XLSM
  onFileChange(evt: any) {
    let status;
    this.FileChangeFirts(evt);
  }

  FileChangeFirts(evt){
    this.onFileChangeSecond(evt);
    let status;
    this.cargandoBD = true;
    let fec1 = new Date();
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    console.log("no entro brothar");
    if(colabInter.FORMATO_ADMITIDO.includes(target.files[0].type)){

      const reader: FileReader = new FileReader();
  		reader.onload = (e: any) => {
  			/* read workbook */
  			const bstr: string = e.target.result;
  			const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
  			/* grab first sheet */
        let numeroHojaALeer = 0;
  			const wsname: string = wb.SheetNames[numeroHojaALeer];
  			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
  			/* save data */
  			this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
        // this.totRows = this.data.length;
        if(this.data.length > 1){
          let numColumnas = this.data[0].length;
          console.log("numero de columnas:"+numColumnas);
          let iterCol = 0;
          this.data[0].forEach( (nombre) => {
            this.nombresColumnas.push(nombre);
            let infoCeldaNombre = wb.Sheets[wsname][colabInter.LETRAS[iterCol]+'1'];
            if(infoCeldaNombre.c){
              let claveColumaArr = infoCeldaNombre.c[0].t.split("|");
              this.clavesColumnas.push(claveColumaArr[0]);
            }
            iterCol++;
          });
          this.nombresColumnasExcel(numColumnas);
          let iterFilas = 0;
          this.data.forEach( (elm) => {
            // for(let i=0;i<numColumnas;i++){
              //   if(elm[i])
              // }
              if(iterFilas > 0){
                this.validacionCelda(elm,iterFilas,numColumnas,1);
              }
              iterFilas++;
            });
            if(this.errores.length >0){
              this.flag_sheet1_errors=1;
            }
            this.cargandoBD = false;
            let fec2 = new Date();
            let fx = (fec2.getTime() - fec1.getTime()) / 1000;
            //console.log("registros cargados: "+this.arregloColaboradores.length);
            //console.log("tiempo de carga de bd en front: "+fx+" segs");
            // console.log("valor final de barporcen: "+this.barPorcen);
            let arcs = evt.target.files
            for (let index = 0; index < arcs.length; index++) {
              const element = arcs[index];
              // console.log(element);
              this.files.push(element.name)
            }
            this.sheet_number = "0";
            return true;
        }
        else{
          this.mensajeSwal(this.mensajesTraducirTS.norows, 3); //norows  vacio
          this.cargandoBD = false;
        }

  		};
  		reader.readAsBinaryString(target.files[0]);
    }
    else{

      this.mensajeSwal(this.mensajesTraducirTS.extmal, 3); //norows  vacio
      this.cargandoBD = false;
    }
  }

  analisisExcel(evt:any){
    let status;
    this.cargandoBD = true;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    if(colabInter.FORMATO_ADMITIDO.includes(target.files[0].type)){
      const reader: FileReader = new FileReader();
  		reader.onload = (e: any) => {
  			/* read workbook */
  			const bstr: string = e.target.result;
  			const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
  			/* grab first sheet */
        // let numeroHojaALeer = 0;
  			this.wsName_ct = wb.SheetNames[0];
  			this.wsName_co = wb.SheetNames[1];
  			const ws_ct: XLSX.WorkSheet = wb.Sheets[this.wsName_ct];
  			const ws_co: XLSX.WorkSheet = wb.Sheets[this.wsName_co];
  			/* save data */
  			// this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
  			let datosCT = <AOA>(XLSX.utils.sheet_to_json(ws_ct, {header: 1}));
  			let datosColab = <AOA>(XLSX.utils.sheet_to_json(ws_co, {header: 1}));
        // console.log(datosCT);
        // console.log(datosColab);
        // if(this.data.length > 1){
          this.analisisHoja(wb,this.wsName_ct,datosCT,2); //1 = colaboradores, 2 = centro de trabajo
          this.analisisHoja(wb,this.wsName_co,datosColab,1); //1 = colaboradores, 2 = centro de trabajo

          let arcs = evt.target.files
          for (let index = 0; index < arcs.length; index++) {
            const element = arcs[index];
            this.files.push(element.name)

          }
        // }
        // else{
        //   this.mensajeSwal(this.mensajesTraducirTS.norows, 3); //norows  vacio
        //   this.cargandoBD = false;
        // }

  		};

  		reader.readAsBinaryString(target.files[0]);
    }
    else{
      this.mensajeSwal(this.mensajesTraducirTS.extmal, 3); //norows  vacio
      this.cargandoBD = false;
    }
  }

  analisisHoja(wb:XLSX.WorkBook, nombreHoja:string, datosHoja:any[], tipo:number){
    console.log("Entro analisis hoja");
    let numColumnas = datosHoja[0].length;
    console.log("numero de columnas:",numColumnas);
    let iterCol = 0;
    datosHoja[0].forEach( (nombre) => {
      if(tipo == 1)
        this.nombresColumnas.push(nombre);
        // console.log("Dude nombre columnas");
        // console.log(this.nombresColumnas);
      if(tipo == 2)
        this.nombresColumnas_CT.push(nombre);
        let infoCeldaNombre = wb.Sheets[nombreHoja][colabInter.LETRAS[iterCol]+'1'];
      if(infoCeldaNombre.c){
        let claveColumaArr = infoCeldaNombre.c[0].t.split("|");
        if(tipo == 1)
          this.clavesColumnas.push(claveColumaArr[0]);
        if(tipo == 2)
          this.clavesColumnas_CT.push(claveColumaArr[0]);
      }
      iterCol++;
    });
    //console.log("Tipo de hoja "+tipo);
    if(tipo == 1)
      this.nombresColumnasExcel(numColumnas);
    if(tipo == 2)
      this.nombresColumnasExcel_CT(numColumnas);

    let iterFilas = 0;
    datosHoja.forEach( (elm) => {
      if(iterFilas > 0){
        this.validacionCelda(elm,iterFilas,numColumnas,tipo);
      }
      iterFilas++;
    });
    //console.log(this.errores.length);
    if(this.errores.length >0){
      this.flag_sheet1_errors=1;
    }
    if(this.errores_CT.length >0){
      this.flag_sheet2_errors=1;
    }

    this.cargandoBD = false;
    // this.sheet_number = "0";
    // return true;
  }

  // Grado academico
  academicoVal = [
    {
      'text':'Sin formación'
    },{
      'text':'Primaria'
    },{
      'text':'Secundaria'
    },{
      'text':'Preparatoria o Bachillerato'
    },{
      'text':'Técnico superior'
    },{
      'text':'Licenciatura'
    },{
      'text':'Maestría'
    },{
      'text':'Doctorado'
    },{
      'text':'No aplica'
    }
  ];
  // Tipo de coontratación
  contratacionlVal = [
    {
      'text':'Por obra o proyecto'
    },{
      'text':'Por tiempo determinado (temporal)'
    },{
      'text':'Tiempo indeterminado'
    },{
      'text':'Honorarios'
    },{
      'text':'No aplica'
    }
  ];
  // Tipo de personal
  personalVal = [
    {
      'text':'Sindicalizado'
    },{
      'text':'Confianza'
    },{
      'text':'Ninguno'
    },{
      'text':'No aplica'
    }
  ];
  // Jornada de trabajo
  //Fijo diurno (entre las 6:00 y 20:00 hrs)
  jornadaVal = [
    {
      'text':'Fijo nocturno (entre las 20:00 y 6:00 hrs)'
    },{
      'text':'Fijo diurno (entre las 6:00 y 20:00 hrs)'
    },{
      'text':'Fijo mixto (combinación de nocturno y diurno)'
    },{
      'text':'No aplica'
    }
  ];
  //Fijo diurno (entre las 6:00 y 20:00 hrs)
  cargoHomologado = [
    {
      'text':'Director o Subdirector'
    },{
      'text':'Gerente o Subgerente'
    },{
      'text':'Jefe de área'
    },{
      'text':'Administrativo'
    },{
      'text':'Operativo'
    },{
      'text':'Técnico'
    },{
      'text':'No aplica'
    }
  ];

  workCondition = [
    {
      'text':'Externo'
    },{
      'text':'Planta'
    },{
      'text':'No aplica'
    }
  ];

  genero = [
    {
      'text':'Masculino'
    },{
      'text':'Femenino'
    },{
      'text':'No aplica'
    }
  ];

  typeofwork = [
    {
      'text':'Asalariado'
    },{
      'text':'Por comisión'
    },{
      'text':'Por hora'
    },{
      'text':'No aplica'
    }
  ];

  typeanswer  = [
    {
      'text':'Cultural Go Survey'
    },{
      'text':'Importado'
    },{
      'text':'Kiosko'
    },{
      'text':'No Responde / Líder Extranjero'
    },{
      'text':'Papel'
    }
  ];

  statusVal=false;
  statusValCont=0;
  flagCant=0;
  flagNoerrors=0;
  validacionCelda(datosFila:any, numFila:number, numColumnas:number, tipo:number){
    let listaErrores: colabInter.listaErrores[] = [];
    for(let i=0;i<numColumnas;i++){
      let errorFnd = false;
      let indiceCol:number;
      if(tipo == 1)
        indiceCol = colabInter.CLAVES_COLUMNAS.indexOf(this.clavesColumnas[i])
      if(tipo == 2)
        indiceCol = colabInter.CLAVES_COLUMNAS_CT.indexOf(this.clavesColumnas_CT[i])
      if(indiceCol != -1){
        let tipoValidacion: string;
        if(tipo == 1)
          tipoValidacion = colabInter.TIPO_VALIDACION[indiceCol];
          //console.log(colabInter.TIPO_VALIDACION[indiceCol]);
        if(tipo == 2)
          tipoValidacion = colabInter.TIPO_VALIDACION_CT[indiceCol];
        switch(tipoValidacion){
          case 'alfabetica':
            if(!this.validacionAlfabetica(datosFila[i])){
              errorFnd = true;
            }
          break;
          case 'alfanumerica':
            if(!this.validacionAlfanumerica(datosFila[i])){
              console.log("ERROR ALFANUMERICA:",datosFila[i]);
              errorFnd = true;
            }
          break;
          case 'numerica':
            if(!this.validacionNumerica(datosFila[i])){
              errorFnd = true;
            }
          break;
          case 'email':
          try {
            if(!this.validacionEmail(datosFila[i].trim())){
              errorFnd = true;
            }

          } catch (error) {
            console.log({
              datosFila,
              i,
              error
            });

          }
          break;
          case 'date':
          if(!this.validacionAlfanumerica(datosFila[i])){
            errorFnd = true;
          }
            // if(!moment(datosFila[i],'DD/MM/YYYY',true).isValid()){
            //   errorFnd = true;
            // }
          break;
          case 'clavenumerica':
            if(!this.validacionClave(datosFila[i])){
              errorFnd = true;
            }
          break;
        }
        if(!errorFnd){
          //comprueba existencia de colaborador en centro de trabajo
          if(tipo == 1){
            if(this.clavesColumnas[i] == 'id_CT'){
              //console.log(this.clavesColumnas[i]);
              if(!this.idsCentrosTrabajo.includes(datosFila[i])){

                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'CT'
                });
                this.erroresTotales++;
              }
            }
          }
          //comprueba vacio
          switch(this.clavesColumnas[i]){
            case 'academico':
              //console.log(datosFila[i]);
              this.flagCant++;
              for(let j=0; j < this.academicoVal.length; j++){
                if(datosFila[i].toLowerCase()  == this.academicoVal[j].text.toLowerCase() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
            break;

            case 'jornada':
              //jornadaVal
              this.flagCant++;
              for(let j=0; j < this.jornadaVal.length; j++){
                if(datosFila[i].toLowerCase()  == this.jornadaVal[j].text.toLowerCase() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
              break;

              case 'personal':
              this.flagCant++;
              for(let j=0; j < this.personalVal.length; j++){
                if(datosFila[i].toLowerCase()  == this.personalVal[j].text.toLowerCase() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
            break;
            //contratacion
            case 'contratacion':
              this.flagCant++;
              // console.log("valores comparados:",{
              //   val1: datosFila[i].toLowerCase(),
              //   val2: this.contratacionlVal
              // });

              for(let j=0; j < this.contratacionlVal.length; j++){
                if(datosFila[i].toLowerCase().trim()  == this.contratacionlVal[j].text.toLowerCase().trim() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
              break;
            //homologado
            case 'homologado':
              this.flagCant++;
              for(let j=0; j < this.cargoHomologado.length; j++){
                try {
                  if(datosFila[i].toLowerCase()  == this.cargoHomologado[j].text.toLowerCase() ){
                    this.flagNoerrors++;
                  }
                } catch (error) {
                  console.log("error de vacio en homologado");

                  this.flagNoerrors = 0;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
              break;
            //workCondition
            case 'workCondition':
              this.flagCant++;
              for(let j=0; j < this.workCondition.length; j++){
                if(datosFila[i].toLowerCase()  == this.workCondition[j].text.toLowerCase() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
              break;
            case 'gender':
              this.flagCant++;
              for(let j=0; j < this.genero.length; j++){
                if(datosFila[i].toLowerCase()  == this.genero[j].text.toLowerCase() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
              break;
            case 'answer':
              this.flagCant++;
              for(let j=0; j < this.typeanswer.length; j++){
                if(datosFila[i].toLowerCase()  == this.typeanswer[j].text.toLowerCase() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
              break;
            case 'typeofwork':
              this.flagCant++;
              for(let j=0; j < this.typeofwork.length; j++){
                if(datosFila[i].toLowerCase()  == this.typeofwork[j].text.toLowerCase() ){
                  this.flagNoerrors++;
                }
              }
              if(this.flagNoerrors == 1){
                this.flagNoerrors=0;
              }else{
                listaErrores.push({
                  columna: this.nombresColumnas[i],
                  dato: datosFila[i],
                  tipoError: 'catSurvey'
                });
                this.erroresTotales++;
                this.flagNoerrors=0;
              }
              break;
          }
          let valVacio: number;
          if(tipo == 1)
            valVacio = colabInter.COLUMNAS_OBLIGATORIAS.indexOf(this.clavesColumnas[i]);
          if(tipo == 2)
            valVacio = colabInter.COLUMNAS_OBLIGATORIAS_CT.indexOf(this.clavesColumnas_CT[i]);
          if(valVacio != -1){
            let vacioFnd = false;
            let tipoValIter: string;
            if(tipo == 1)
              tipoValIter = colabInter.TIPO_VALIDACION[i];
            if(tipo == 2)
              tipoValIter = colabInter.TIPO_VALIDACION_CT[i];
            if(tipoValIter == 'numerica'){
              if(datosFila[i] == null)
              vacioFnd = true;
            }
            else{
              if(datosFila[i] != null){
                if(datosFila[i].length == 0){
                  vacioFnd = true;
                }
              }
              else{
                vacioFnd = true;
              }
            }
            if(vacioFnd){
              let nomCol: string;
              if(tipo == 1)
                nomCol = this.nombresColumnas[i];
              if(tipo == 2)
                nomCol = this.nombresColumnas_CT[i];
              listaErrores.push({
                columna: nomCol,
                dato: datosFila[i],
                tipoError: 'vacio'
              });
              if(tipo == 1)
                this.erroresTotales++;
              if(tipo == 2)
                this.erroresTotales_CT++;
            }
            else{
              if(colabInter.COLUMNAS_NO_REPETIR.indexOf(this.clavesColumnas[i]) != -1){

                if(this.buscaRepetidos(datosFila[i],this.clavesColumnas[i],numColumnas)){

                  if(i == 1){
                    listaErrores.push({
                      columna: this.nombresColumnas[i],
                      dato: datosFila[i],
                      tipoError: 'repetido'
                    });

                  }else{
                    listaErrores.push({
                      columna: this.nombresColumnas[i],
                      dato: datosFila[i],
                      tipoError: 'repetidoMail'
                    });

                  }

                  this.erroresTotales++;
                }
              }
            }
          }
        }
        else{
          let nomCol: string;
          if(tipo == 1)
            nomCol = this.nombresColumnas[i];
          if(tipo == 2)
            nomCol = this.nombresColumnas_CT[i];
          listaErrores.push({
            columna: nomCol,
            dato: datosFila[i],
            tipoError: tipoValidacion
          });
          if(tipo == 1)
            this.erroresTotales++;
          if(tipo == 2)
            this.erroresTotales_CT++;
        }
      }
      else{
        //crear error de columa no encontrad
        let nomCol: string;
        if(tipo == 1)
          nomCol = this.nombresColumnas[i];
        if(tipo == 2)
          nomCol = this.nombresColumnas_CT[i];
        listaErrores.push({
          columna: nomCol,
          dato: datosFila[i],
          tipoError: 'columna'
        });
        if(tipo == 1)
          this.erroresTotales++;
        if(tipo == 2)
          this.erroresTotales_CT++;
      }
    }
    //   BRO THIS IS NEW AND IT´S JUST A PROOF
    //console.log("Cantidad que entro "+this.flagCant);
    //console.log("Math columns "+ this.flagNoerrors);
    //Si al terminar el ciclo de la fila la lista de errores es mayor a cero se agrega fila a array de errores
    if(listaErrores.length > 0){
      if(tipo == 1)
        this.errores.push({
          numeroFila:numFila,
          datos: datosFila,
          listaErrores: listaErrores
        });
      if(tipo == 2)
        this.errores_CT.push({
          numeroFila:numFila,
          datos: datosFila,
          listaErrores: listaErrores
        })

    }
    else{ //si no hay errores, se agrega a array de filas correctas
      if(tipo == 1)
        this.filaCorrecta(datosFila,numColumnas);
      if(tipo == 2)
        this.filaCorrecta_CT(datosFila,numColumnas);
    }
  }

  validacionAlfabetica(dato:any){
    return this.regexAlfabetico.test(dato);
  }
  validacionAlfanumerica(dato:any){
    return this.regexAlfanumerico.test(dato);
  }
  validacionNumerica(dato:any){
    return this.regexNumerico.test(dato);
  }
  validacionEmail(dato:any){
    return this.regexEmail.test(dato);
  }

  validacionClave(dato:any){
    return this.regexClave.test(dato);
  }



  buscaRepetidos(datosFila:any, clave:string, numColumnas:number){
    let repetidoEncontrado = false;
    let BreakException = {};
    try {
      this.arregloColaboradores.forEach((colaborador) => {
        for(let i=0;i<numColumnas;i++){
          switch(clave){
            case 'fullName': if(colaborador.fullName == datosFila) repetidoEncontrado = true; break;
            case 'ownKey': if(colaborador.ownKey == datosFila) repetidoEncontrado = true; break;
            case 'email': if(colaborador.email == datosFila) repetidoEncontrado = true; break;
            case 'phone': if(colaborador.phone == datosFila) repetidoEncontrado = true; break;
            case 'extension': if(colaborador.extension == datosFila) repetidoEncontrado = true; break;
            case 'cellphone': if(colaborador.cellphone == datosFila) repetidoEncontrado = true; break;
            case 'country': if(colaborador.country == datosFila) repetidoEncontrado = true; break;
            case 'location': if(colaborador.location == datosFila) repetidoEncontrado = true; break;
            case 'area': if(colaborador.area == datosFila) repetidoEncontrado = true; break;
            case 'bossKey': if(colaborador.bossKey == datosFila) repetidoEncontrado = true; break;
            case 'native': if(colaborador.native == datosFila) repetidoEncontrado = true; break;
            case 'charge': if(colaborador.charge == datosFila) repetidoEncontrado = true; break;
            case 'answer': if(colaborador.answer == datosFila) repetidoEncontrado = true; break;
            case 'age': if(colaborador.age == datosFila) repetidoEncontrado = true; break;
            case 'gender': if(colaborador.gender == datosFila) repetidoEncontrado = true; break;
            case 'typeofwork': if(colaborador.typeofwork == datosFila) repetidoEncontrado = true; break;
            case 'workCondition': if(colaborador.workCondition == datosFila) repetidoEncontrado = true; break;
            case 'antiquity': if(colaborador.antiquity == datosFila) repetidoEncontrado = true; break;
            case 'geo_1': if(colaborador.geo_1 == datosFila) repetidoEncontrado = true; break;
            case 'geo_2': if(colaborador.geo_2 == datosFila) repetidoEncontrado = true; break;
            case 'geo_3': if(colaborador.geo_3 == datosFila) repetidoEncontrado = true; break;
            case 'geo_4': if(colaborador.geo_4 == datosFila) repetidoEncontrado = true; break;
            case 'geo_5': if(colaborador.geo_5 == datosFila) repetidoEncontrado = true; break;
            case 'structure_1': if(colaborador.structure_1 == datosFila) repetidoEncontrado = true; break;
            case 'structure_2': if(colaborador.structure_2 == datosFila) repetidoEncontrado = true; break;
            case 'structure_3': if(colaborador.structure_3 == datosFila) repetidoEncontrado = true; break;
            case 'structure_4': if(colaborador.structure_4 == datosFila) repetidoEncontrado = true; break;
            case 'structure_5': if(colaborador.structure_5 == datosFila) repetidoEncontrado = true; break;
            case 'structure_6': if(colaborador.structure_6 == datosFila) repetidoEncontrado = true; break;
            case 'structure_7': if(colaborador.structure_7 == datosFila) repetidoEncontrado = true; break;
            case 'structure_8': if(colaborador.structure_8 == datosFila) repetidoEncontrado = true; break;
            case 'structure_9': if(colaborador.structure_9 == datosFila) repetidoEncontrado = true; break;
            case 'structure_10': if(colaborador.structure_10 == datosFila) repetidoEncontrado = true; break;
            case 'homologado': if(colaborador.homologado == datosFila) repetidoEncontrado = true; break;
            case 'academico': if(colaborador.academico == datosFila) repetidoEncontrado = true; break;
            case 'contratacion': if(colaborador.contratacion == datosFila) repetidoEncontrado = true; break;
            case 'personal': if(colaborador.personal == datosFila) repetidoEncontrado = true; break;
            case 'jornada': if(colaborador.jornada == datosFila) repetidoEncontrado = true; break;
            case 'rotacion': if(colaborador.rotacion == datosFila) repetidoEncontrado = true; break;
          }
          if(repetidoEncontrado) break;
        }
        if(repetidoEncontrado) throw BreakException;
      });
    } catch (e) {
        if (e !== BreakException) throw e;
    };
    return repetidoEncontrado;
  }

  filaCorrecta(datosFila:any,numColumnas:number){
    let colaborador = {} as colabInter.Colaborador;
    colaborador.productoId = this.productoCertificar.idNorma35;
    for(let i=0;i<numColumnas;i++){
      switch(this.clavesColumnas[i]){
        case 'fullName': colaborador.fullName = datosFila[i].trim(); break;
        case 'ownKey': colaborador.ownKey = datosFila[i]; break;
        case 'email': colaborador.email = datosFila[i].trim(); break;
        case 'phone': colaborador.phone = datosFila[i]; break;
        case 'extension': colaborador.extension = datosFila[i]; break;
        case 'cellphone': colaborador.cellphone = datosFila[i]; break;
        case 'country': colaborador.country = datosFila[i]; break;
        case 'location': colaborador.location = datosFila[i]; break;
        case 'area': colaborador.area = datosFila[i]; break;
        case 'bossKey': colaborador.bossKey = datosFila[i]; break;
        case 'native': colaborador.native = datosFila[i]; break;
        case 'charge': colaborador.charge = datosFila[i]; break;
        case 'answer': colaborador.answer = datosFila[i]; break;
        case 'age': colaborador.age = datosFila[i]; break;
        case 'gender': colaborador.gender = datosFila[i].charAt(0).toUpperCase()+datosFila[i].slice(1); break;
        case 'typeofwork': colaborador.typeofwork = datosFila[i]; break;
        case 'workCondition': colaborador.workCondition = datosFila[i]; break;
        case 'antiquity': colaborador.antiquity = this.fechaCorrecta(datosFila[i]); break;
        // case 'antiquity': colaborador.antiquity = datosFila[i]; break;
        case 'geo_1': colaborador.geo_1 = datosFila[i]; break;
        case 'geo_2': colaborador.geo_2 = datosFila[i]; break;
        case 'geo_3': colaborador.geo_3 = datosFila[i]; break;
        case 'geo_4': colaborador.geo_4 = datosFila[i]; break;
        case 'geo_5': colaborador.geo_5 = datosFila[i]; break;
        case 'structure_1': colaborador.structure_1 = datosFila[i]; break;
        case 'structure_2': colaborador.structure_2 = datosFila[i]; break;
        case 'structure_3': colaborador.structure_3 = datosFila[i]; break;
        case 'structure_4': colaborador.structure_4 = datosFila[i]; break;
        case 'structure_5': colaborador.structure_5 = datosFila[i]; break;
        case 'structure_6': colaborador.structure_6 = datosFila[i]; break;
        case 'structure_7': colaborador.structure_7 = datosFila[i]; break;
        case 'structure_8': colaborador.structure_8 = datosFila[i]; break;
        case 'structure_9': colaborador.structure_9 = datosFila[i]; break;
        case 'structure_10': colaborador.structure_10 = datosFila[i]; break;
        case 'homologado': colaborador.homologado = datosFila[i]; break;
        case 'academico': colaborador.academico = datosFila[i]; break;
        case 'contratacion': colaborador.contratacion = datosFila[i]; break;
        case 'personal': colaborador.personal = datosFila[i]; break;
        case 'jornada': colaborador.jornada = datosFila[i]; break;
        case 'rotacion': colaborador.rotacion = datosFila[i]; break;
        case 'id_CT': colaborador.id_CT = datosFila[i]; break;
      }
    }
    this.arregloColaboradores.push(colaborador);
    //console.log(this.arregloColaboradores);
  }




  fechaCorrecta(fechaActual){
  let fechaFinal = "";
  if(isNaN(fechaActual)){
    fechaFinal = fechaActual;
  }
  else{
    let fechaInicial = "30-12-1899";
    let fechaReal = moment(fechaInicial, "DD-MM-YYYY");
    fechaReal.add(fechaActual, 'days');
    fechaFinal = moment(fechaReal).format('DD/MM/YYYY');
  }

  return fechaFinal;
}

  nombresColumnasExcel(numColumnas:number){
    // let this.nombresColumnasBD = {} as colabInter.nombresColumnasEnBD;
    this.nombresColumnasBD.productoId = this.productoCertificar.idNorma35;
    for(let i=0;i<numColumnas;i++){
      switch(this.clavesColumnas[i]){
        case 'fullName': this.nombresColumnasBD.fullName = this.nombresColumnas[i].trim(); break;
        case 'ownKey': this.nombresColumnasBD.ownKey = this.nombresColumnas[i]; break;
        case 'email': this.nombresColumnasBD.email = this.nombresColumnas[i].trim(); break;
        case 'phone': this.nombresColumnasBD.phone = this.nombresColumnas[i]; break;
        case 'extension': this.nombresColumnasBD.extension = this.nombresColumnas[i]; break;
        case 'cellphone': this.nombresColumnasBD.cellphone = this.nombresColumnas[i]; break;
        case 'country': this.nombresColumnasBD.country = this.nombresColumnas[i]; break;
        case 'location': this.nombresColumnasBD.location = this.nombresColumnas[i]; break;
        case 'area': this.nombresColumnasBD.area = this.nombresColumnas[i]; break;
        case 'bossKey': this.nombresColumnasBD.bossKey = this.nombresColumnas[i]; break;
        case 'native': this.nombresColumnasBD.native = this.nombresColumnas[i]; break;
        case 'charge': this.nombresColumnasBD.charge = this.nombresColumnas[i]; break;
        case 'answer': this.nombresColumnasBD.answer = this.nombresColumnas[i]; break;
        case 'age': this.nombresColumnasBD.age = this.nombresColumnas[i]; break;
        case 'gender': this.nombresColumnasBD.gender = this.nombresColumnas[i]; break;
        case 'typeofwork': this.nombresColumnasBD.typeofwork = this.nombresColumnas[i]; break;
        case 'workCondition': this.nombresColumnasBD.workCondition = this.nombresColumnas[i]; break;
        case 'antiquity': this.nombresColumnasBD.antiquity = this.nombresColumnas[i]; break;
        case 'geo_1': this.nombresColumnasBD.geo_1 = this.nombresColumnas[i].trim(); break;
        case 'geo_2': this.nombresColumnasBD.geo_2 = this.nombresColumnas[i].trim(); break;
        case 'geo_3': this.nombresColumnasBD.geo_3 = this.nombresColumnas[i].trim(); break;
        case 'geo_4': this.nombresColumnasBD.geo_4 = this.nombresColumnas[i].trim(); break;
        case 'geo_5': this.nombresColumnasBD.geo_5 = this.nombresColumnas[i].trim(); break;
        case 'structure_1': this.nombresColumnasBD.structure_1 = this.nombresColumnas[i].trim(); break;
        case 'structure_2': this.nombresColumnasBD.structure_2 = this.nombresColumnas[i].trim(); break;
        case 'structure_3': this.nombresColumnasBD.structure_3 = this.nombresColumnas[i].trim(); break;
        case 'structure_4': this.nombresColumnasBD.structure_4 = this.nombresColumnas[i].trim(); break;
        case 'structure_5': this.nombresColumnasBD.structure_5 = this.nombresColumnas[i].trim(); break;
        case 'structure_6': this.nombresColumnasBD.structure_6 = this.nombresColumnas[i].trim(); break;
        case 'structure_7': this.nombresColumnasBD.structure_7 = this.nombresColumnas[i].trim(); break;
        case 'structure_8': this.nombresColumnasBD.structure_8 = this.nombresColumnas[i].trim(); break;
        case 'structure_9': this.nombresColumnasBD.structure_9 = this.nombresColumnas[i].trim(); break;
        case 'structure_10': this.nombresColumnasBD.structure_10 = this.nombresColumnas[i].trim(); break;
        case 'id_CT': this.nombresColumnasBD.id_CT = this.nombresColumnas[i]; break;
        case 'homologado': this.nombresColumnasBD.homologado = this.nombresColumnas[i]; break;
        case 'academico': this.nombresColumnasBD.academico = this.nombresColumnas[i]; break;
        case 'contratacion': this.nombresColumnasBD.contratacion = this.nombresColumnas[i]; break;
        case 'personal': this.nombresColumnasBD.personal = this.nombresColumnas[i]; break;
        case 'jornada': this.nombresColumnasBD.jornada = this.nombresColumnas[i]; break;
        case 'rotacion': this.nombresColumnasBD.rotacion = this.nombresColumnas[i]; break;
      }
    }
    // console.log(this.nombresColumnasBD);
  }

  guardarColaboradoresBD(){
    if(!this.pasoCompleto){
      if(this.arregloColaboradores.length > 0 && this.errores.length == 0 && this.erroresTotales == 0 && this.arregloCentro_Trabajo.length > 0 && this.errores_CT.length == 0 && this.erroresTotales_CT == 0){

        Swal.fire({
          title: this.mensajesTraducirTS.guarda_1+this.arregloColaboradores.length+","+this.arregloCentro_Trabajo.length+this.mensajesTraducirTS.guarda_2,
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,


          confirmButtonText: this.mensajesTraducirTS.si,
          cancelButtonText: this.mensajesTraducirTS.no
        }).then((result) => {
          if (result.value) {
            this.guardandoBD = true;
            this.guardandoBD_CT = true;


            this.colaboradoresService.guardaCentro35(this.productoCertificar_CT.fechaNorma35, this.nombresColumnasBD_CT, this.arregloCentro_Trabajo).subscribe( (respuesta: colabInter.respuestaGuardaBD) => {

              if(respuesta.message == '230'){

                this.colaboradoresService.guardaColaboradores35(this.productoCertificar.fechaNorma35, this.nombresColumnasBD, this.arregloColaboradores)
                .subscribe( (respuesta: colabInter.respuestaGuardaBD) => {
                  if(respuesta.message == 'success'){

                    //CODIGO YA QUE GUARDO
                    this.colaboradoresService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
                    .subscribe( (getFast: colabInter.getBDFast) => {
                      if(getFast.message == 'Success'){

                        this.colaboradoresService.getCentrosFast(this.productoCertificar_CT.fechaNorma35, this.productoCertificar_CT.idNorma35)
                          .subscribe( (getFastCT: colabInter.getBD_CTFast) => {
                            if(getFastCT.message == 'Success'){

                              this.deleteAttachment();
                              this.colabsEnBD = getFast.numeroColaboradores;
                              this.fechaCarga = getFast.fecha;

                              this.CT_EnBD = getFastCT.numeroCentrosTrabajo;
                              this.fechaCarga_CT = getFastCT.fecha;

                              this.guardandoBD = false;
                              this.guardandoBD_CT = false;
                              this.stored = true;
                              this.stored_CT = true;
                              this.mensajeSwal(this.mensajesTraducirTS.guardado, 1);
                            }
                            else{
                              this.mensajeSwal(this.mensajesTraducirTS.gua_err, 3);
                            }
                        });

                      }
                      else{
                        this.mensajeSwal(this.mensajesTraducirTS.gua_err, 3);
                      }
                    });
                    //CODIGO YA QUE GUARDO

                  }
                  else{
                    console.log("error para guardar colabs");
                    this.mensajeSwal(this.mensajesTraducirTS.gua_err, 3);
                  }
                });


              }else{
                console.log("error para guardar centros");
                this.mensajeSwal(this.mensajesTraducirTS.gua_err, 3);
              }
            });


          }
        });
      }
    }
    else{
      //mensaje swal
    }
  }

  borrarColaboradores(){

    if(!this.pasoCompleto){

      this.fechaCarga="2019-10-24T03:05:22.590Z";
      if(this.stored && this.colabsEnBD > 0 && this.fechaCarga){
        Swal.fire({
          title: this.mensajesTraducirTS.delete_1+this.colabsEnBD+","+this.CT_EnBD+this.mensajesTraducirTS.delete_2,
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,


          confirmButtonText: this.mensajesTraducirTS.si,
          cancelButtonText: this.mensajesTraducirTS.no
        }).then((result) => {
          if (result.value) {
            let inicio = new Date();
            let fin: any;
            this.colaboradoresService.borrarColaboradores(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
            .subscribe( (resultado: colabInter.respuestaEliminaBD) => {
              if(resultado.message == '231' && resultado.respuesta == this.colabsEnBD){
                this.stored = false;
                this.colabsEnBD = 0;
                this.fechaCarga = null;
                //this.mensajeSwal(this.mensajesTraducirTS.del_ok_1+resultado.respuesta+this.mensajesTraducirTS.del_ok_2, 1);
                this.borrarCentro();
              }
              else{
                this.mensajeSwal(this.mensajesTraducirTS.del_err, 3);
              }
            });

          }
        });
      }
    }
    else{
      this.aletaRestric('COLABORADORES.RESTRICCION',null,'warning');
    }
  }

  descargaExcel(){
    Swal.fire({
      title: this.mensajesTraducirTS.excel,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: this.mensajesTraducirTS.titulo,
      Subject: this.mensajesTraducirTS.asunto,
      Author: this.mensajesTraducirTS.autor,
      CreatedDate: new Date()
    };
    wb.SheetNames.push(this.mensajesTraducirTS.hoja);
    var ws_data = [];
    let nombresColumnas:string[] = [];

    this.colaboradoresService.getColaboradoresFull(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
    .subscribe( (getFull: colabInter.getBDFull) => {
      console.log("Respuesta",getFull);

      if(getFull.message == 'Success' && getFull.bdcolaboradores.length > 0){
         colabInter.CLAVES_COLUMNACT.forEach( (nombre) =>{
           console.log(nombre);
           /*switch (nombre) {
            case 'NOMBRE DEL COLABORADOR': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelGeográfico_1': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelGeográfico_2': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelGeográfico_3': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelGeográfico_4': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelGeográfico_5': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_1': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_2': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_3': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_4': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_5': nombresColumnas.push(getFull.columnas.fullName); break;
            case'NivelEstructural_6': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_7': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_8': nombresColumnas.push(getFull.columnas.fullName); break;
            case'NivelEstructural_9': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'NivelEstructural_10': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'CARGO O FUNCIÓN HOMOLOGADO': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'GÉNERO': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'GRADO ACADÉMICO	Condiciones en el ambiente de trabajo': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Ambiente de trabajo	Carga de trabajo': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Falta de control sobre el trabajo': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Factores propios de la actividad': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Jornada de trabajo': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Interferencia en la relación trabajo-familia': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Organización del tiempo de trabajo	Liderazgo': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Relaciones en el trabajo': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Violencia': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Liderazgo y relaciones en el trabajo': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Reconocimiento del desempeño': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Insuficiente sentido de pertenencia e: nombresColumnas.push(getFull.columnas.fullName); break; inestabilid': nombresColumnas.push(getFull.columnas.fullName); break;
            case 'Entorno organizacional': nombresColumnas.push(getFull.columnas.fullName); break;
           }*/
            //nombresColumnas.push(nombre);
           switch(nombre){
             case 'fullName': nombresColumnas.push(getFull.columnas.fullName); break;
             case 'ownKey': nombresColumnas.push(getFull.columnas.ownKey); break;
             case 'email': nombresColumnas.push(getFull.columnas.email); break;
             case 'age': nombresColumnas.push(getFull.columnas.age); break;
             case 'bossKey': nombresColumnas.push(getFull.columnas.bossKey); break;
             case 'country': nombresColumnas.push(getFull.columnas.country); break;
             case 'location': nombresColumnas.push(getFull.columnas.location); break;
             case 'area': nombresColumnas.push(getFull.columnas.area); break;
             case 'charge': nombresColumnas.push(getFull.columnas.charge); break;
             case 'homologado': nombresColumnas.push(getFull.columnas.homologado); break;
             case 'antiquity': nombresColumnas.push(getFull.columnas.antiquity); break;
             case 'workCondition': nombresColumnas.push(getFull.columnas.workCondition); break;
             case 'typeofwork': nombresColumnas.push(getFull.columnas.typeofwork); break;
             case 'gender': nombresColumnas.push(getFull.columnas.gender); break
             case 'academico': nombresColumnas.push(getFull.columnas.academico); break;
             case 'contratacion': nombresColumnas.push(getFull.columnas.contratacion); break;
             case 'personal': nombresColumnas.push(getFull.columnas.personal); break;
             case 'jornada': nombresColumnas.push(getFull.columnas.jornada); break;
             case 'rotacion': nombresColumnas.push(getFull.columnas.rotacion); break;
             case 'phone': nombresColumnas.push(getFull.columnas.phone); break;
             case 'extension': nombresColumnas.push(getFull.columnas.extension); break
             case 'cellphone': nombresColumnas.push(getFull.columnas.cellphone); break;
             case 'native': nombresColumnas.push(getFull.columnas.native); break;
             case 'answer': nombresColumnas.push(getFull.columnas.answer); break;
             case 'geo_1': nombresColumnas.push(getFull.columnas.geo_1); break;
             case 'geo_2': nombresColumnas.push(getFull.columnas.geo_2); break;
             case 'geo_3': nombresColumnas.push(getFull.columnas.geo_3); break;
             case 'geo_4': nombresColumnas.push(getFull.columnas.geo_4); break;
             case 'geo_5': nombresColumnas.push(getFull.columnas.geo_5); break;
             case 'structure_1': nombresColumnas.push(getFull.columnas.structure_1); break;
             case 'structure_2': nombresColumnas.push(getFull.columnas.structure_2); break;
             case 'structure_3': nombresColumnas.push(getFull.columnas.structure_3); break;
             case 'structure_4': nombresColumnas.push(getFull.columnas.structure_4); break;
             case 'structure_5': nombresColumnas.push(getFull.columnas.structure_5); break;
             case 'structure_6': nombresColumnas.push(getFull.columnas.structure_6); break;
             case 'structure_7': nombresColumnas.push(getFull.columnas.structure_7); break;
             case 'structure_8': nombresColumnas.push(getFull.columnas.structure_8); break;
             case 'structure_9': nombresColumnas.push(getFull.columnas.structure_9); break;
             case 'structure_10': nombresColumnas.push(getFull.columnas.structure_10); break;
             case 'id_CT': nombresColumnas.push(getFull.columnas.id_CT); break;
           }
         });
        ws_data.push(nombresColumnas);

        getFull.bdcolaboradores.forEach( (colaborador) => {
          let datosColaboradores:any[] = [];
          colabInter.CLAVES_COLUMNAS.forEach( (nombre) => {
            switch(nombre){
              case 'fullName': datosColaboradores.push(colaborador.fullName); break;
              case 'ownKey': datosColaboradores.push(colaborador.ownKey); break;
              case 'email': datosColaboradores.push(colaborador.email); break;
              case 'phone': datosColaboradores.push(colaborador.phone); break;
              case 'extension': datosColaboradores.push(colaborador.extension); break;
              case 'cellphone': datosColaboradores.push(colaborador.cellphone); break;
              case 'country': datosColaboradores.push(colaborador.country); break;
              case 'location': datosColaboradores.push(colaborador.location); break;
              case 'area': datosColaboradores.push(colaborador.area); break;
              case 'bossKey': datosColaboradores.push(colaborador.bossKey); break;
              case 'native': datosColaboradores.push(colaborador.native); break;
              case 'charge': datosColaboradores.push(colaborador.charge); break;
              case 'answer': datosColaboradores.push(colaborador.answer); break;
              case 'age': datosColaboradores.push(colaborador.age); break;
              case 'gender': datosColaboradores.push(colaborador.gender); break;
              case 'typeofwork': datosColaboradores.push(colaborador.typeofwork); break;
              case 'workCondition': datosColaboradores.push(colaborador.workCondition); break;
              case 'antiquity': datosColaboradores.push(colaborador.antiquity); break;
              case 'geo_1': datosColaboradores.push(colaborador.geo_1); break;
              case 'geo_2': datosColaboradores.push(colaborador.geo_2); break;
              case 'geo_3': datosColaboradores.push(colaborador.geo_3); break;
              case 'geo_4': datosColaboradores.push(colaborador.geo_4); break;
              case 'geo_5': datosColaboradores.push(colaborador.geo_5); break;
              case 'structure_1': datosColaboradores.push(colaborador.structure_1); break;
              case 'structure_2': datosColaboradores.push(colaborador.structure_2); break;
              case 'structure_3': datosColaboradores.push(colaborador.structure_3); break;
              case 'structure_4': datosColaboradores.push(colaborador.structure_4); break;
              case 'structure_5': datosColaboradores.push(colaborador.structure_5); break;
              case 'structure_6': datosColaboradores.push(colaborador.structure_6); break;
              case 'structure_7': datosColaboradores.push(colaborador.structure_7); break;
              case 'structure_8': datosColaboradores.push(colaborador.structure_8); break;
              case 'structure_9': datosColaboradores.push(colaborador.structure_9); break;
              case 'structure_10': datosColaboradores.push(colaborador.structure_10); break;
              case 'id_CT': datosColaboradores.push(colaborador.id_CT);break;
              case 'homologado': datosColaboradores.push(colaborador.homologado); break;
              case 'academico': datosColaboradores.push(colaborador.academico); break;
              case 'contratacion': datosColaboradores.push(colaborador.contratacion); break;
              case 'personal': datosColaboradores.push(colaborador.personal); break;
              case 'jornada': datosColaboradores.push(colaborador.jornada); break;
              case 'rotacion': datosColaboradores.push(colaborador.rotacion); break;
            }
          });
          //console.log("Colaboradores")

          ws_data.push(datosColaboradores);
        console.log(ws_data);
        });

       var ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[this.mensajesTraducirTS.hoja] = ws;

        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

        var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

        saveAs(new Blob([buf],{type:"application/octet-stream"}), this.mensajesTraducirTS.titulo+' - '+this.nombreEmpresa+'.xlsx');
        Swal.close();
      }
    });
  }

  deleteAttachment(index?:number, origen?:boolean) {
    // console.log("Files");
    // console.log(this.files);
    if(origen){
      Swal.fire({
        title: this.mensajesTraducirTS.delfile,
        icon: 'success',
        confirmButtonColor: '#e40601'
      });
    }
    this.files = [];
    this.data = [];
    this.arregloColaboradores = [];
    this.arregloCentro_Trabajo = [];
    this.errores = [];
    this.errores_CT = [];
    this.erroresTotales = 0;
    this.erroresTotales_CT = 0;
    this.nombresColumnas = [];
    this.nombresColumnas_CT = [];
    this.clavesColumnas = [];
    this.clavesColumnas_CT = [];
    this.stored = false;
    this.stored_CT = false;
    this.colabsEnBD = 0;
    this.CT_EnBD=0;
    this.fechaCarga = null;
    this.fechaCarga_CT = null;
    this.totRows = 0;
    this.flag_sheet1_errors=0;
    this.flag_sheet2_errors=0;
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  completarPaso(){

    if(this.pasoCompleto){
      this.aletaRestric('COLABORADORES.COMPLETADO',null,'warning');
    }
    else{
      if(this.stored && this.colabsEnBD > 0 && this.fechaCarga_CT){
        this.aletaRestric('COLABORADORES.COMPLETAR',true);
      }
      else{
        this.aletaRestric('COLABORADORES.NADA',null,'warning');
      }
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }
  enviaOrdenWizard(){
    this.wizardService35.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          console.log('this.productoCertificar.idNorma35',this.productoCertificar.idNorma35);

          this.colaboradoresService.saveStatus(this.productoCertificar.idNorma35).subscribe( (data: backInter.RespuestaGen) => {
            console.log("Bro");
            console.log(data);
            if(data.message == '211' || data.message == '200'){
              this.aletaRestric('COLABORADORES.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }

  desbloquearPasoColabNorma(){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.TITULO_DESBLOQUEAR';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          console.log('this.productoCertificar.idNorma35',this.productoCertificar.idNorma35);
          this.colaboradoresService.desbloquearPasoColabNomr(this.productoCertificar.idNorma35).subscribe( (data: backInter.RespuestaGen) => {
            console.log("Bro");
            console.log(data);
            if(data.message == '211' || data.message == '200'){
              this.aletaRestric('COLABORADORES.SUCCES',null,'success');
              this.pasoCompleto = false;
              this.enviaOrdenWizard();
            };
          });
        }
      });

  }
  /*****************************SEGUNDA HOJA EXCEL     SEGUNDA HOJA EXCEL     SEGUNDA HOJA EXCEL ***************************/
  onFileChangeSecond(evt) {
    this.cargandadoBDSegunda = true;
    let fec1 = new Date();
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    if(colabInter.FORMATO_ADMITIDO.includes(target.files[0].type)){
      const reader: FileReader = new FileReader();
  		reader.onload = (e: any) => {
  			/* read workbook */
  			const bstr: string = e.target.result;
  			const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
  			/* grab first sheet */
        let numeroHojaALeer = 1;
  			const wsname: string = wb.SheetNames[numeroHojaALeer];
  			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
  			/* save data */
  			this.dataSegunda = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
  			// console.log(this.data.length);
        // this.totRows = this.data.length;
        if(this.dataSegunda.length > 1){
          let numColumnas = this.dataSegunda[0].length;

          let iterCol = 0;
          this.dataSegunda[0].forEach( (nombre) => {
            this.nombresColumnas_CT.push(nombre);
            let infoCeldaNombre = wb.Sheets[wsname][colabInter.LETRAS[iterCol]+'1'];
            if(infoCeldaNombre.c){
              let claveColumaArr = infoCeldaNombre.c[0].t.split("|");
              this.clavesColumnas_CT.push(claveColumaArr[0]);
            }
            iterCol++;
          });

          this.nombresColumnasExcel_CT(numColumnas);
          let iterFilas = 0;
          this.dataSegunda.forEach( (elm) => {
            // for(let i=0;i<numColumnas;i++){
              //   if(elm[i])
              // }
              if(iterFilas > 0){
                this.validacionCelda_CT(elm,iterFilas,numColumnas,2);
              }
              iterFilas++;
            });

            if(this.errores_CT.length > 0 ){
              //console.log("Flag");
              this.flag_sheet2_errors=1;
              //console.log(this.flag_sheet2_errors);
            }
            // this.arregloColaboradores = this.arregloColaboradores.splice(1,this.arregloColaboradores.length);
            // console.log(this.arregloColaboradores);
            this.cargandadoBDSegunda = false;
            let fec2 = new Date();
            let fx = (fec2.getTime() - fec1.getTime()) / 1000;

            //console.log("registros cargados: "+this.arregloCentro_Trabajo.length);
            //console.log("tiempo de carga de bd en front: "+fx+" segs");
            // console.log("valor final de barporcen: "+this.barPorcen);
            let arcs = evt.target.files
            for (let index = 0; index < arcs.length; index++) {
              const element = arcs[index];
              //console.log(element);
              //this.files.push(element.name)
            }
            this.sheet_number = "1";
        }
        else{
          this.mensajeSwal(this.mensajesTraducirTS.norows, 3); //norows  vacio
          this.cargandadoBDSegunda = false;
          return false;
        }

  		};
  		reader.readAsBinaryString(target.files[0]);
    }
    else{
      this.mensajeSwal(this.mensajesTraducirTS.extmal, 3); //norows  vacio
      this.cargandadoBDSegunda = false;
    }

  }

  nombresColumnasExcel_CT(numColumnas:number){
    //console.log("Entro a hoja de centros de trabajo");
    //console.log(this.nombresColumnas_CT);

    // let this.nombresColumnasBD = {} as colabInter.nombresColumnasEnBD;
    this.nombresColumnasBD_CT.productoId = this.productoCertificar.idNorma35;
    for(let i=0;i<numColumnas;i++){
      switch(this.clavesColumnas_CT[i]){
        case 'nombre_CT': this.nombresColumnasBD_CT.nombre_CT = this.nombresColumnas_CT[i]; break;
        case 'domicilio_CT': this.nombresColumnasBD_CT.domicilio_CT = this.nombresColumnas_CT[i]; break;
        case 'actividad_principal_CT': this.nombresColumnasBD_CT.actividad_principal_CT = this.nombresColumnas_CT[i]; break;
        case 'tamanio_CT': this.nombresColumnasBD.phone = this.nombresColumnas_CT[i]; break;
        case 'nombre_responsable_CT': this.nombresColumnasBD_CT.nombre_responsable_CT = this.nombresColumnas_CT[i]; break;
        case 'email_responsable_CT': this.nombresColumnasBD_CT.email_responsable_CT = this.nombresColumnas_CT[i]; break;
        case 'email_razon_social': this.nombresColumnasBD_CT.email_razon_social = this.nombresColumnas_CT[i]; break;
      }
    }
    console.log("nombresColumnasExcel_CT");
    console.log(this.nombresColumnasBD_CT);
  }

  validacionCelda_CT(datosFila:any, numFila:number, numColumnas:number,numhoja){
    console.log("Entro Validación CT");
    let listaErrores: colabInter.listaErrores[] = [];
    for(let i=0;i<numColumnas;i++){
      let errorFnd = false;
      let indiceCol = colabInter.CLAVES_COLUMNAS_CT.indexOf(this.clavesColumnas_CT[i])
      if(indiceCol != -1){
        let tipoValidacion = colabInter.TIPO_VALIDACION_CT[indiceCol];
        switch(tipoValidacion){
          case 'alfabetica':
            if(!this.validacionAlfabetica(datosFila[i])){
              errorFnd = true;
            }
          break;
          case 'alfanumerica':
            if(!this.validacionAlfanumerica(datosFila[i])){
              console.log("ERROR ALFANUMERICA CT:",datosFila[i]);

              errorFnd = true;
            }
          break;
          case 'numerica':
            if(!this.validacionNumerica(datosFila[i])){
              errorFnd = true;
            }
          break;
          case 'email':
            if(!this.validacionEmail(datosFila[i].trim())){
              errorFnd = true;
            }
          break;
          case 'clavenumerica':
            if(!this.validacionClave(datosFila[i].trim())){
              errorFnd = true;
            }
          break;
        }
        if(!errorFnd){
          //comprueba vacio
          if(colabInter.COLUMNAS_OBLIGATORIAS_CT.indexOf(this.clavesColumnas_CT[i]) != -1){
            let vacioFnd = false;
            // if(typeof datosFila[i] == 'number'){
            if(colabInter.TIPO_VALIDACION_CT[i] == 'numerica'){
              if(datosFila[i] == null)
              vacioFnd = true;
            }
            else{
              if(datosFila[i] != null){
                if(datosFila[i].length == 0){
                  vacioFnd = true;
                }
              }
              else{
                vacioFnd = true;
              }
            }
            if(vacioFnd){
              listaErrores.push({
                columna: this.nombresColumnas_CT[i],
                dato: datosFila[i],
                tipoError: 'vacio'
              });
              this.erroresTotales_CT++;
            }
          }
        }
        else{
          listaErrores.push({
            columna: this.nombresColumnas_CT[i],
            dato: datosFila[i],
            tipoError: tipoValidacion
          });
          this.erroresTotales_CT++;
        }
      }
      else{
        //crear error de columa no encontrad
        listaErrores.push({
          columna: this.nombresColumnas_CT[i],
          dato: datosFila[i],
          tipoError: 'columna'
        });
        this.erroresTotales_CT++;
      }
    }
    //Si al terminar el ciclo de la fila la lista de errores es mayor a cero se agrega fila a array de errores
    if(listaErrores.length > 0){
      this.errores_CT.push({
        numeroFila:numFila,
        datos: datosFila,
        listaErrores: listaErrores
      })
    }
    else{ //si no hay errores, se agrega a array de filas correctas
      //console.log("DATOS ULTIMO IF");
      //console.log(datosFila);
      this.filaCorrecta_CT(datosFila,numColumnas);
    }
  }

  filaCorrecta_CT(datosFila:any,numColumnas:number){

    let colaborador = {} as colabInter.CentroTrabajo;
    colaborador.productoId = this.productoCertificar.idNorma35;

    for(let i=0;i<numColumnas;i++){
      switch(this.clavesColumnas_CT[i]){
        case 'id_CT': colaborador.id_CT = datosFila[i]; this.idsCentrosTrabajo.push(datosFila[i]); break;
        case 'nombre_CT': colaborador.nombre_CT = datosFila[i]; break;
        case 'domicilio_CT':  colaborador.domicilio_CT = datosFila[i]; break;
        case 'actividad_principal_CT':  colaborador.actividad_principal_CT = datosFila[i]; break;
        case 'tamanio_CT':  colaborador.tamanio_CT = datosFila[i]; break;
        case 'nombre_responsable_CT':  colaborador.nombre_responsable_CT = datosFila[i]; break;
        case 'email_responsable_CT':  colaborador.email_responsable_CT = datosFila[i]; break;
        case 'email_razon_social':colaborador.email_razon_social = datosFila[i]; break;
      }
    }
    this.arregloCentro_Trabajo.push(colaborador);

  }

  guardarCentros_TrabajoBD(){
    //console.log();
      if(this.arregloCentro_Trabajo.length > 0 && this.errores_CT.length == 0 && this.erroresTotales_CT == 0){
        this.guardandoBD_CT = true;
        let inicio = new Date();
        let fin: any;
        console.log("columnas");
        console.log(this.nombresColumnasBD_CT);
        console.log(this.arregloCentro_Trabajo);
        this.colaboradoresService.guardaCentro35(this.productoCertificar_CT.fechaNorma35, this.nombresColumnasBD_CT, this.arregloCentro_Trabajo)
          .subscribe( (respuesta: colabInter.respuestaGuardaBD) => {

          if(respuesta.message == '230'){
            fin = new Date();
            let fx = (fin.getTime() - inicio.getTime()) / 1000;
            console.log("tiempo de guardado de bd en backend: "+fx+" segs");
              this.colaboradoresService.getCentrosFast(this.productoCertificar_CT.fechaNorma35, this.productoCertificar_CT.idNorma35)
                .subscribe( (getFast: colabInter.getBDFast) => {
                  console.log(getFast);
                  if(getFast.message == 'Success'){
                    this.deleteAttachment();

                    this.guardandoBD_CT = false;
                    this.CT_EnBD = getFast.numeroColaboradores;
                    this.fechaCarga_CT = getFast.fecha;
                    this.stored_CT = true;
                    this.mensajeSwal(this.mensajesTraducirTS.guardado, 1);
                  }
                  else{
                    this.mensajeSwal(this.mensajesTraducirTS.gua_err, 3);
                  }
            });
          }else{
            this.mensajeSwal(this.mensajesTraducirTS.gua_err, 3);
            }
          });
      }
  }

  borrarCentro(){
    if(!this.pasoCompleto){
      //this.fechaCarga="2019-10-24T03:05:22.590Z";
      if(this.stored_CT && this.CT_EnBD > 0 && this.fechaCarga_CT){
        console.log("Entro para borrarr");
            let inicio = new Date();
            let fin: any;
            this.colaboradoresService.borrarCentros_trabajo(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
            .subscribe( (resultado: colabInter.respuestaEliminaBD) => {
              if(resultado.message == '231' && resultado.respuesta == this.CT_EnBD){
                this.stored_CT = false;
                this.CT_EnBD = 0;
                this.fechaCarga_CT = null;
                this.mensajeSwal(this.mensajesTraducirTS.del_ok_1+this.mensajesTraducirTS.del_ok_2, 1);
              }
              else{
                this.mensajeSwal(this.mensajesTraducirTS.del_err, 3);
              }
            });


      }
    }
    else{
      this.aletaRestric('COLABORADORES.RESTRICCION',null,'warning');
    }
  }

  descargaExcelCT(){
    Swal.fire({
      title: this.mensajesTraducirTS.excel,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: this.mensajesTraducirTS.titulo,
      Subject: this.mensajesTraducirTS.asunto,
      Author: this.mensajesTraducirTS.autor,
      CreatedDate: new Date()
    };
    console.log(this,this.mensajesTraducirTS.hoja);
    wb.SheetNames.push(this.mensajesTraducirTS.hoja);
    var ws_data = [];
    let nombresColumnas:string[] = [];

    this.colaboradoresService.getFull_CT(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
    .subscribe( (getFull: colabInter.getBDFullCT) => {
      console.log("Respuesta del servicio get");
      console.log(getFull);
      if(getFull.message == 'Success' && getFull.bdcentrosTrabajo.length > 0){
        colabInter.CLAVES_COLUMNASCT.forEach( (nombre) =>{

          // nombresColumnas.push(nombre);
          console.log("Nombre" + nombre);
          switch(nombre){
            case 'id_CT': nombresColumnas.push("Id Centro de trabajo"); break;
            //case 'productoId': nombresColumnas.push("Id centro de trabajo"); break;
            case 'nombre_CT': nombresColumnas.push(getFull.columnas.nombre_CT); break;
            case 'domicilio_CT': nombresColumnas.push(getFull.columnas.domicilio_CT); break;
            case 'actividad_principal_CT': nombresColumnas.push(getFull.columnas.actividad_principal_CT); break;
            case 'nombre_responsable_CT': nombresColumnas.push(getFull.columnas.nombre_responsable_CT); break;
            case 'email_responsable_CT': nombresColumnas.push(getFull.columnas.email_responsable_CT); break;
            case 'email_razon_social': nombresColumnas.push(getFull.columnas.email_razon_social);break;

          }
        });
        //console.log("Nombre columnas");
        //console.log(nombresColumnas);
        ws_data.push(nombresColumnas);
        getFull.bdcentrosTrabajo.forEach( (CT) => {


          let dataCT:any[] = [];
          // for(let i=0;i<nombresColumnas.length;i++){
          colabInter.CLAVES_COLUMNASCT.forEach( (nombre) => {
            //console.log("Nombre brothar "+nombre);
            switch(nombre){
              //case 'productoId': dataCT.push(CT.productoId); break;
              case 'id_CT': dataCT.push(CT.id_CT); break;
              case 'nombre_CT': dataCT.push(CT.nombre_CT); break;
              case 'domicilio_CT': dataCT.push(CT.domicilio_CT); break;
              case 'actividad_principal_CT': dataCT.push(CT.actividad_principal_CT); break;
              case 'nombre_responsable_CT': dataCT.push(CT.nombre_responsable_CT); break;
              case 'email_responsable_CT': dataCT.push(CT.email_responsable_CT); break;
              case 'email_razon_social': dataCT.push(CT.email_razon_social); break;
            }
          });
          console.log(dataCT);
          ws_data.push(dataCT);

        });

        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[this.mensajesTraducirTS.hoja] = ws;

        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

        var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        let texto = 'CERTIFICAR.COLABORADORES.TITULOCT';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

        saveAs(new Blob([buf],{type:"application/octet-stream"}), texto+' - '+this.nombreEmpresa+'.xlsx');
        Swal.close();
      }
    });
  }





}
